<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Periódicos</h1>
                                    <p class="modern-subtitle">Quatro periódicos temáticos de referência nacional, com edições mensais para profissionais que precisam estar sempre atualizados.</p>
                                </div>
                                <div class="header-actions" v-if="user">
                                    <div class="search-box">
                                        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                        </svg>
                                        <input type="text"
                                               class="modern-search-input"
                                               placeholder="Pesquisar artigos, edições ou temas..."
                                               aria-label="Pesquisar periódicos"
                                               v-model="pesquisa"
                                               @keyup.enter="pesquisar" />
                                        <button class="modern-btn modern-btn-primary" type="button" @click="pesquisar">
                                            Buscar
                                        </button>
                                        <ManualFerramenta :name="'Manual Periódicos'"
                                                          :btnClass="'btn-manual-tool'"
                                                          :nameBtn="'Manual'"
                                                          :urlPdf="'/manuais/FERRAMENTA PERIODICOS.pdf'" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <main class="periodicos-content">
                        <div class="editions-container">
                            <div class="featured-grid">
                                <div class="journal-group-card"
                                     v-for="tipo in filteredTipos"
                                     :key="tipo.idTipoPeriodico">
                                    <div class="card-cover card-cover--title">
                                        <img :src="tipo.urlImagem"
                                             :alt="tipo.nmTipoPeriodico"
                                             class="card-cover__logo"
                                             @error="onImgError" />
                                    </div>

                                    <div class="card-info">
                                        <div class="card-footer">
                                            <span class="card-date">{{ periodoTipo(tipo) }}</span>
                                            <router-link v-if="user"
                                                         class="card-btn"
                                                         :to="{ name: 'ListaPeriodicos', params: { tipo: tipo.idTipoPeriodico } }">
                                                Ver edições →
                                            </router-link>
                                        </div>

                                        <div class="periodicos-mini">
                                            <BoxPeriodico v-for="p in tipo.lstPeriodicos"
                                                          :key="p.idPeriodico"
                                                          :periodico="p" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import BoxPeriodico from '@/components/Ferramentas/Periodicos/BoxPeriodico'

    import logoLicicon from '@/assets/img/Periodicos/logo_revista_licicon.png'
    import logoNp from '@/assets/img/Periodicos/logo_revista_np_grande.png'
    import logoPregoeiro from '@/assets/img/Periodicos/logo_revista_pregoeiro_grande.png'
    import logoGovernanca from '@/assets/img/Periodicos/logo_revista_governanca_grande.png'
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'


    export default {
        name: 'PeriodicosHome',
        components: { BoxPeriodico, Header, Modais, ManualFerramenta },

        computed: {
            user() {
                return this.$store.state.user
            },
            filteredTipos() {
                if (this.activeTab === 'all') return this.lstTipoPeriodico
                return this.lstTipoPeriodico.filter((t) => t.idTipoPeriodico === this.activeTab)
            },
        },

        data() {
            return {
                lstTipoPeriodico: [],
                pesquisa: '',
                activeTab: 'all',
                urlPlanos: '#',
            }
        },

        methods: {
            pesquisar() {
                if (this.pesquisa && this.pesquisa.trim() !== '') {
                    this.$router.push({ name: 'PesquisaPeriodicos', params: { termo: this.pesquisa.trim() } })
                }
            },

            logout() {
                this.$store.commit('setUser', null)
            },

            onImgError(e) {
                e.target.src = '/image-not-found.jpg'
            },

            getClassTipoPeriodico(nmTipoPeriodico) {
                if (nmTipoPeriodico.includes('Licicon')) return 'licicon'
                if (nmTipoPeriodico.includes('Pregoeiro')) return 'pregoeiro'
                if (nmTipoPeriodico.includes('Negócios')) return 'np'
                if (nmTipoPeriodico.includes('Governança')) return 'governanca'
                return 'none'
            },

            getImagem(nmTipoPeriodico) {
                if (nmTipoPeriodico.includes('Licicon')) return logoLicicon
                if (nmTipoPeriodico.includes('Pregoeiro')) return logoPregoeiro
                if (nmTipoPeriodico.includes('Negócios')) return logoNp
                if (nmTipoPeriodico.includes('Governança')) return logoGovernanca
                return null
            },


            descricaoTipo(tipo) {
                switch (tipo.classe) {
                    case 'licicon':
                        return 'Revista de Licitações e Contratos, com foco prático e doutrinário.'
                    case 'np':
                        return 'Atualizações e análises sobre temas estratégicos na gestão pública.'
                    case 'pregoeiro':
                        return 'Conteúdo para pregoeiros, agentes de contratação e equipes de apoio.'
                    case 'governanca':
                        return 'Gestão, integridade, riscos e governança aplicada ao setor público.'
                    default:
                        return 'Conteúdo técnico e atual para sua atuação profissional.'
                }
            },

            periodoTipo() {
                return 'Últimas edições'
            },

            load() {
                this.carregaTipoPeriodico()
            },

            carregaTipoPeriodico() {
                const $this = this
                axios
                    .get(`${urlApi}/Periodico/Get`)
                    .then((res) => {
                        if (res.data.success) {
                            $this.lstTipoPeriodico = []
                            if (res.data.data != null) {
                                for (let i = 0; i < res.data.data.length; i++) {
                                    const tipoPeriodico = res.data.data[i]
                                    tipoPeriodico.urlImagem = $this.getImagem(tipoPeriodico.nmTipoPeriodico)
                                    tipoPeriodico.classe = $this.getClassTipoPeriodico(tipoPeriodico.nmTipoPeriodico)

                                    tipoPeriodico.lstPeriodicos = (tipoPeriodico.periodicos || []).slice(0, 1)
                                    $this.lstTipoPeriodico.push(tipoPeriodico)
                                }
                            }
                        } else {
                            avisoErro('Não foi possível carregar os periódicos')
                            $this.lstTipoPeriodico = []
                        }
                    })
                    .catch(() => {
                        avisoErro('Não foi possível carregar os periódicos')
                        $this.lstTipoPeriodico = []
                    })
            },
        },

        mounted() {
            this.load()
        },

        watch: {
            user() {
                this.carregaTipoPeriodico()
            },
        },

    }
</script>

<style lang="scss" scoped>
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=DM+Sans:wght@300;400;500;600&family=Merriweather:ital,wght@0,900;1,400&display=swap');

        .modern-header {
            background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
            padding: 12px 0;
            border-bottom: 1px solid #e5e7eb;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
        }

        [data-bs-theme="dark"] .modern-header {
            background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
            border-bottom-color: #374151;
        }

        .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
            padding: 2px 0;
        }

        .title-section {
            flex: 1 1 280px;
            min-width: 200px;
            max-width: 720px;
        }

        .modern-title {
            font-size: 32px;
            font-weight: 800;
            color: #1f2937;
            margin-bottom: 6px;
            letter-spacing: -0.5px;
            line-height: 1.2;
        }

        [data-bs-theme="dark"] .modern-title {
            color: #f9fafb;
        }

        .modern-subtitle {
            font-size: 14px;
            color: #6b7280;
            font-weight: 500;
            margin: 0;
        }

        [data-bs-theme="dark"] .modern-subtitle {
            color: #9ca3af;
        }

        .header-actions {
            display: flex;
            align-items: center;
            flex: 1 1 320px;
            max-width: 480px;
        }

        .search-box {
            position: relative;
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100%;
        }

        .search-icon {
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #9ca3af;
            pointer-events: none;
            z-index: 1;
        }

        .modern-search-input {
            flex: 1;
            min-width: 0;
            padding: 10px 16px 10px 46px;
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            font-size: 14px;
            transition: all 0.3s ease;
            background: #f9fafb;
            color: #1f2937;
        }

        .modern-search-input:focus {
            outline: none;
            border-color: #2563eb;
            background: white;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

        [data-bs-theme="dark"] .modern-search-input {
            background: #111827;
            border-color: #374151;
            color: #e5e7eb;
        }

        .modern-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 10px 20px;
            border-radius: 10px;
            font-weight: 600;
            font-size: 14px;
            border: none;
            cursor: pointer;
            min-height: 42px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            white-space: nowrap;
        }

        .modern-btn-primary {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
        }

        .modern-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

        @media (max-width: 768px) {
            .modern-header {
                padding: 20px 0;
            }

            .header-content {
                flex-direction: column;
                align-items: flex-start;
            }

            .title-section,
            .header-actions {
                max-width: 100%;
                width: 100%;
            }

            .modern-title {
                font-size: 24px;
            }
        }

        /* Cores usadas pelos journal-group-card (var) */
        .periodicos-content {
            --warm-white: #fdfcf9;
            --warm-off: #f5f2eb;
            --gold: #C8922A;
            --gold-light: #E8A83A;
            --gold-pale: #fdf0d5;
            --dark: #1A1A2E;
            --dark-mid: #2a2a42;
            --muted: #7a7060;
            --border: #DEDBD4;
            --border-gold: rgba(200, 146, 42, 0.3);
            --shadow-sm: 0 2px 8px rgba(26, 26, 46, 0.07);
            --shadow-md: 0 8px 32px rgba(26, 26, 46, 0.1);
            --shadow-lg: 0 20px 60px rgba(26, 26, 46, 0.14);
            font-family: 'DM Sans', sans-serif;
            background: var(--warm-white);
            color: var(--dark);
            padding: 3rem;
        }

        /* BUTTONS */
        .btn {
            padding: 0.5rem 1.25rem;
            border-radius: 4px;
            font-family: 'DM Sans', sans-serif;
            font-size: 0.78rem;
            font-weight: 600;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.2s;
            border: none;
            text-decoration: none;
            display: inline-block;
        }

        .btn-outline {
            background: transparent;
            border: 1px solid var(--gold);
            color: var(--gold);
        }

        .btn-outline:hover {
            background: var(--gold);
            color: #fff;
        }

        .btn-gold {
            background: var(--gold);
            color: #fff;
        }

        .btn-gold:hover {
            background: var(--gold-light);
        }

        .btn.big {
            padding: 0.85rem 2rem;
            font-size: 0.85rem;
        }

        /* MAIN */
        .editions-container {
            position: relative;
            padding-bottom: 1.5rem;
        }

        .featured-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1.5rem;
        }

        .journal-group-card {
            background: #fff;
            border: 1px solid var(--border);
            border-radius: 12px;
            overflow: hidden;
            transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;
            position: relative;
            display: flex;
            flex-direction: column;
            box-shadow: var(--shadow-sm);
        }

        .journal-group-card:hover {
            border-color: var(--gold);
            box-shadow: var(--shadow-lg), 0 0 0 1px var(--border-gold);
            transform: translateY(-4px);
        }

        .card-cover {
            position: relative;
            background: var(--warm-off);
            border-bottom: 1px solid var(--border);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 26px 22px 18px;
            min-height: 92px;
        }

        .card-cover--title {
            border-bottom: 1px solid var(--border);
        }

        /* Remove o filter brightness do original — no tema claro as logos
           já são coloridas e não precisam ser embranquecidas */
        .card-cover__logo {
            max-width: 220px;
            width: 100%;
            max-height: 52px;
            object-fit: contain;
            object-position: center;
            display: block;
            filter: brightness(0);
            opacity: 1;
        }

        .card-info {
            padding: 1.25rem 1.25rem 1.5rem;
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            background: #fff;
        }

        .card-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 0.5rem;
        }

        .card-date {
            font-size: 0.7rem;
            color: var(--muted);
        }

        .card-btn {
            font-size: 0.68rem;
            font-weight: 600;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: var(--gold);
            text-decoration: none;
            display: flex;
            align-items: center;
            gap: 0.3rem;
            transition: gap 0.2s;
        }

        .card-btn:hover {
            gap: 0.5rem;
        }

        .periodicos-mini {
            display: grid;
            grid-template-columns: 1fr;
            gap: 0.75rem;
            margin-top: 1rem;
        }

        /* PAYWALL BANNER */
        .paywall-banner {
            position: relative;
            overflow: hidden;
            background: linear-gradient(135deg, var(--gold-pale) 0%, #fff 60%);
            border: 1px solid var(--border-gold);
            border-radius: 16px;
            padding: 3rem;
            margin: 2rem 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 2rem;
            box-shadow: var(--shadow-md);
        }

        .paywall-banner::before {
            content: '';
            position: absolute;
            top: -40px;
            right: -40px;
            width: 200px;
            height: 200px;
            background: radial-gradient(circle, rgba(200, 146, 42, 0.15) 0%, transparent 70%);
            pointer-events: none;
        }

        .paywall-eyebrow {
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: var(--gold);
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            gap: 10px;

            &::before {
                content: '';
                width: 20px;
                height: 2px;
                background: var(--gold);
                display: inline-block;
            }
        }

        .paywall-journals {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            margin-top: 1.5rem;
        }

        .paywall-journal {
            display: flex;
            align-items: flex-start;
            gap: 0.75rem;
            font-size: 0.83rem;
            color: var(--dark-mid);
            line-height: 1.5;

            strong {
                display: block;
                font-weight: 600;
                color: var(--dark);
                margin-bottom: 0.1rem;
            }
        }

        .journal-icon {
            font-size: 1.1rem;
            line-height: 1.4;
            flex-shrink: 0;
        }

        .paywall-tagline {
            font-size: 0.78rem;
            color: var(--muted);
            font-style: italic;
            margin-top: 0.25rem;
            max-width: 280px;
            line-height: 1.5;
        }

        .paywall-text h3 {
            font-family: 'Playfair Display', serif;
            font-size: 1.75rem;
            font-weight: 700;
            margin-bottom: 0.75rem;
            color: var(--dark);
        }

        .paywall-text p {
            color: var(--muted);
            font-size: 0.9rem;
            line-height: 1.6;
            max-width: 480px;
        }

        .paywall-perks {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;
            margin-top: 1.25rem;
        }

        .perk {
            display: flex;
            align-items: center;
            gap: 0.6rem;
            font-size: 0.85rem;
            color: var(--dark-mid);
        }

        .perk::before {
            content: '✦';
            color: var(--gold);
            font-size: 0.6rem;
        }

        .paywall-actions {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            align-items: flex-start;
        }

        /* RESPONSIVE */
        @media (max-width: 1200px) {
            .featured-grid {
                grid-template-columns: repeat(3, 1fr);
            }
        }

        @media (max-width: 1000px) {
            .periodicos-content {
                padding: 1.5rem 1.25rem;
            }

            .featured-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .paywall-banner {
                flex-direction: column;
                align-items: flex-start;
            }
        }

        @media (max-width: 575px) {
            .featured-grid {
                grid-template-columns: 1fr;
            }
        }

    :deep(.btn-manual-tool) {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        min-height: 42px;
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
        color: #fff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.btn-manual-tool:hover) {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%) !important;
        transform: translateY(-2px);
    }
</style>